import React, { useState } from "react";
import styled from "styled-components";
import Modal from "../../../../../components/modal";
import { DayPicker } from "react-day-picker";
import Button from "../../../../../components/button";

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 32px;
`;

const modifiersStyles = {
  selected: {
    color: "#FFF",
    background: "#05d141",
  },
};

export const BulkEditCheckin = (props) => {
  const [selected, setSelected] = useState("");

  const today = new Date();
  const disabledDays = [
    { before: today },
    {
      after: new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate() + 6
      ),
    },
  ];

  // const monthSpan = this.props.nextPossibleWeighInDate.getDate() > 21

  const dayOfWeekOptions = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "'No preference'",
  ];
  let selectedDay = "'No preference'";
  if (selected) {
    selectedDay = dayOfWeekOptions[selected.getDay()];
  }
  return (
    <Modal
      title="Select a check-in day"
      submitLabel="Confirm"
      open={props.open}
      onClose={props.onClose}
      handleSubmit={() => props.handleSubmit(selected)}
    >
      <Container>
        <DayPicker
          mode="single"
          modifiersStyles={modifiersStyles}
          disabled={disabledDays}
          selected={selected}
          onSelect={setSelected}
          // month={desiredNextWeighInDate}
          // disableNavigation={!monthSpan}
          // fixedWeeks={monthSpan}
          // onDayClick={this.handleDayClick}
        />
      </Container>
      <Button 
        label={'No preference'}
        onClick={() => setSelected(null)}
        style={{ marginBottom: "32px" }}
      />
      {selectedDay && (
        <>
          <p>Clients will have their check-in day set to {selectedDay}</p>
          <p>
            If a client's next check-in is within the next 5 days, their next
            check-in will be pushed a week later.
          </p>
        </>
      )}
    </Modal>
  );
};
